<template>
  <CountrySelect
    v-model="country"
    :label="$tt('nationality')"
    :countries="countries"
    :hint="!hideHint && $tt('according_to_passport')"
    :rules="[required]"
  />
</template>

<script setup lang="ts">
import type { CountryIso } from '~/types';
const { required } = useValidation();

const country = defineModel<CountryIso>({ required: true });
defineProps<{
  hideHint?: boolean;
  countries?: CountryIso[];
}>();
</script>